// utils
import { addSpaceIfCamelCase, cn } from "src/utils/common.helper"
import { useState } from "react"
// Instead of InfoCircleIcon, use an appropriate icon from your library
// If you have a HelpIcon, QuestionIcon, or similar information-related icon, use that instead
// For example:
import { UserSquareIcon } from "@assets/icons"

export const WidgetItemInfo = ({
  label,
  data,
  className = "",
  isDisorder = false,
  allDisorders = [],
}) => {
  const [showTooltip, setShowTooltip] = useState(false)

  // Simple info icon as inline SVG in case no suitable icon exists in your library
  const InfoIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4 text-[var(--primary-blue)] cursor-pointer"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M12 8h.01"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M11 12h1v4h1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )

  return (
    <div
      className={cn(
        "flex flex-col gap-2 w-full text-[var(--text-light-gray)]",
        label.toLowerCase() !== "email" && "capitalize",
        className
      )}
    >
      <span className="text-sm font-bold">{addSpaceIfCamelCase(label)}</span>
      <div className="flex items-center gap-2">
        <p className="text-sm">{data}</p>

        {isDisorder && allDisorders.length > 0 && (
          <div className="relative">
            <InfoIcon />

            {showTooltip && (
              <div className="absolute z-10 bottom-6 left-0 bg-[var(--primary-blue)] text-white shadow-lg rounded-md p-3 min-w-[200px]">
                {/* Close button */}
                <button
                  className="absolute top-1 right-1 text-white hover:text-gray-200"
                  onClick={() => setShowTooltip(false)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>

                <p className="text-xs font-medium mb-2">All Disorders:</p>
                <p
                  style={{
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "16px",
                    letterSpacing: "0.4px",
                  }}
                >
                  {allDisorders.join(", ")}
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
